import * as Namespaces from "./namespaces";

const locales = {
  [Namespaces.NAVIGATION]: {
    el: {
      Home: "Αρχική",
      Logout: "Αποσύνδεση",
      nav_products: "ΠΡΟΪΟΝΤΑ",
      nav_brands: "BRANDS",
      nav_about: "ΣΧΕΤΙΚΑ ΜΕ ΕΜΑΣ",
      account_popup_login_description:
        "Σύνδεσου με τα στοιχεία σου για γρήγορη αγορά",
      account_popup_login_button: "ΣΥΝΔΕΣΗ",
      account_popup_first_time_question: "Πρώτη Φορά αγοράζεις από εμάς;",
      account_popup_signup_button: "ΔΗΜΙΟΥΡΓΙΑ ΛΟΓΑΡΙΑΣΜΟΥ",
      account_popup_profile: "Το Προφίλ μου",
      account_popup_orders: "Οι παραγγελίες μου",
      account_popup_favorites: "Τα αγαπημένα μου",
      account_popup_logout: "ΑΠΟΣΥΝΔΕΣΗ",
      account_popup_my_account: "Ο ΛΟΓΑΡΙΑΣΜΟΣ ΜΟΥ",
      'Account has been activated.Now you can log in':'Ο λογαριασμός σας έχει ενεργοποιηθεί. Τώρα μπορείτε να συνδεθείτε',
      'Activation link is not valid':'Ο σύνδεσμος ενεργοποίησης δεν είναι έγκυρος'
    },
    en: {
      Home: "Home",
      Logout: "Logout",
      nav_products: "PRODUCTS",
      nav_brands: "BRANDS",
      nav_about: "ABOUT US",
      account_popup_login_description:
        "Sign in with your credentials for faster checkout",
      account_popup_login_button: "Sign In",
      account_popup_first_time_question: "Shopping with us for the first time?",
      account_popup_signup_button: "Create Account",
      account_popup_profile: "My Profile",
      account_popup_orders: "My Orders",
      account_popup_favorites: "My Favorites",
      account_popup_logout: "Logout",
      account_popup_my_account: "My Account",
    },
  },
  [Namespaces.FILES]: {
    el: {
      Description: "Περιγραφή",
      Cancel: "Ακύρωση",
      Uploading: "Μεταμόρφωση",
      "No description yet": "Χωρίς περιγραφή",
      Download: "Λήψη",
      Edit: "Επεξεργασία",
      Delete: "Διαγραφή",
      "Upload File": "Ανέβασμα Αρχείου",
      "Drag 'n' drop some files here, or click to select files":
        "Σύρετε αρχεία εδώ, ή πατήστε για να επιλέξετε.",
      "Uploaded File(s)": "Ανεβασμένα Αρχεία",
    },
    en: {
      Description: "Description",
      Cancel: "Cancel",
      Uploading: "Uploading",
      "No description yet": "No description yet",
      Download: "Download",
      Edit: "Edit",
      Delete: "Delete",
      "Upload File": "Upload File",
      "Drag 'n' drop some files here, or click to select files":
        "Drag 'n' drop some files here, or click to select files",
      "Uploaded File(s)": "Uploaded File(s)",
    },
  },
  [Namespaces.CONFIRMATION]: {
    el: {
      NO: "ΟΧΙ",
      YES: "ΝΑΙ",
    },
    en: {
      NO: "NO",
      YES: "YES",
    },
  },
  [Namespaces.AXIOS_ERROR_MESSAGE]: {
    el: {
      More: "Περισσότερα..",
      Less: "Λιγότερα",
      Unauthorized: "Ο χρήστης δεν έχει πρόσβαση στην ιστοσελίδα.",
      "Failed to get notifications.": "Αδυναμία φόρτωσης ειδοποιήσεων.",
      "Duplicate Entry": "Υπάρχει ήδη αυτή η εγγραφή",
      "Not Found": "Δεν βρέθηκε",
      errorMessage: "Μήνυμα",
      Message: "Μήνυμα",
      moreMessage: "",
      Code: "Κωδικός",
      Status: "Status",
      "No data found or an error occurred!":
        "Δεν βρέθηκαν δεδομένα ή προέκυψε κάποιο σφάλμα!",
      "An error occurred!": "Προέκυψε κάποιο σφάλμα!",
      "No data found!": "Δεν βρέθηκαν δεδομένα!",
    },
    en: {
      More: "More..",
      Less: "Less",
      Unauthorized: "User does not have access to the website.",
      "Failed to get notifications.": "Failed to get notifications.",
      "Duplicate Entry": "This entry already exists",
      "Not Found": "Not Found",
      errorMessage: "Message",
      Message: "Message",
      moreMessage: "",
      Code: "Code",
      Status: "Status",
      "No data found or an error occurred!":
        "No data found or an error occurred!",
      "An error occurred!": "An error occurred!",
      "No data found!": "No data found!",
    },
  },
  [Namespaces.COPY_TO_CLIPBOARD]: {
    el: {
      Copy: "Αντιγραφή",
      Copied: "Αντιγράφηκε",
    },
    en: {
      Copy: "Copy",
      Copied: "Copied",
    },
  },
  [Namespaces.ALERTS]: {
    el: {
      "An error occurred!": "Παρουσιάστηκε κάποιο σφάλμα!",
      Details: "Λεπτομέρειες",
      Cancel: "Ακύρωση",
      Confirm: "Επιβεβαίωση",
    },
    en: {
      "An error occurred!": "An error occurred!",
      Details: "Details",
      Cancel: "Cancel",
      Confirm: "Confirm",
    },
  },
  [Namespaces.MUI_GRID]: {
    el: {
      Add: "Προσθήκη",
      Actions: "Ενέργειες",
      "Press Yes to confirm entry deletion.":
        "Πατήστε ΝΑΙ για να επιβεβαιώσετε τη διαγραφή της εγγραφής.",
      "Delete Entry Confirmation.": "Επιβεβαίωση Διαγραφής.",
      no: "Όχι",
      yes: "Ναι",
    },
    en: {
      Add: "Add",
      Actions: "Actions",
      "Press Yes to confirm entry deletion.":
        "Press Yes to confirm entry deletion.",
      "Delete Entry Confirmation.": "Delete Entry Confirmation.",
      no: "No",
      yes: "Yes",
    },
  },
  [Namespaces.GRID_STATE]: {
    el: {
      "Custom view": "Προσαρμοσμένη όψη",
      Cancel: "Ακύρωση",
      "Create view": "Νέα Όψη",
      "Save current view": "Αποθήκευση όψης",
      "Custom view label": "Ετικέτα όψης",
      "New custom view": "Νέα προσαρμοσμένη όψη",
    },
    en: {
      "Custom view": "Custom view",
      Cancel: "Cancel",
      "Create view": "Create view",
      "Save current view": "Save current view",
      "Custom view label": "Custom view label",
      "New custom view": "New custom view",
    },
  },
  [Namespaces.EDITABLE_MUI_GRID]: {
    el: {
      Add: "Προσθήκη",
      Actions: "Ενέργειες",
      "Press Yes to confirm entry deletion.":
        "Πατήστε ΝΑΙ για να επιβεβαιώσετε τη διαγραφή της εγγραφής.",
      "Delete Entry Confirmation.": "Επιβεβαίωση Διαγραφής.",
      Confirm: "Επιβεβαίωση",
      Cancel: "Ακύρωση",
      Save: "Αποθήκευση",
      Edit: "Επεξεργασία",
      Delete: "Διαγραφή",
    },
    en: {
      Add: "Add",
      Actions: "Actions",
      "Press Yes to confirm entry deletion.":
        "Press Yes to confirm entry deletion.",
      "Delete Entry Confirmation.": "Delete Entry Confirmation.",
      Confirm: "Confirm",
      Cancel: "Cancel",
      Save: "Save",
      Edit: "Edit",
      Delete: "Delete",
    },
  },
  [Namespaces.CONTENT_NOT_FOUND]: {
    el: {
      "Content not available or no data found for this section!":
        "Το περιεχόμενο δεν είναι διαθέσιμο ή δεν βρέθηκαν δεδομένα!",
    },
    en: {
      "Content not available or no data found for this section!":
        "Content not available or no data found for this section!",
    },
  },
  [Namespaces.MENU]: {
    el: {
      PRODUCTS: "ΠΡΟΪΟΝΤΑ",
      search: "Αναζητήση",
      search_found_results: "Σου βρήκαμε τα παρακάτω",
      search_from: "από τα",
      search_no_results: "δεν βρέθηκαν προϊόντα",
      search_view_all: "ΠΡΟΒΟΛΗ ΟΛΩΝ",
      my_cart: "ΤΟ ΚΑΛΑΘΙ ΜΟΥ",
      empty_cart: "Το καλάθι σας είναι κενό",
      total: "ΣΥΝΟΛΟ",
      order_completion: "ΟΛΟΚΛΗΡΩΣΗ ΠΑΡΑΓΓΕΛΙΑΣ",
    },
    en: {
      PRODUCTS: "PRODUCTS",
      search: "Search",
      search_found_results: "We found the following",
      search_from: "from",
      search_no_results: "No products found",
      search_view_all: "VIEW ALL",
      my_cart: "MY CART",
      empty_cart: "Your cart is empty",
      total: "TOTAL",
      order_completion: "ORDER COMPLETION",
    },
  },
  [Namespaces.FOOTER]: {
    el: {
      brew: "BREW",
      lunora: "LUNORA",
      company: "ΕΤΑΙΡΕΙΑ",
      contact: "ΕΠΙΚΟΙΝΩΝΙΑ",
      brew_filters: "ΦΙΛΤΡΑ",
      brew_pour_over: "POUR OVER",
      brew_scales: "ΖΥΓΑΡΙΕΣ",
      brew_pitchers: "ΚΑΝΑΤΕΣ",
      brew_kettles: "ΒΡΑΣΤΗΡΕΣ",
      brew_thermos: "ΘΕΡΜΟΣ - TUMBLERS",
      brew_cleaners: "ΚΑΘΑΡΙΣΤΙΚΑ",
      brew_espresso: "ESPRESSO MAKERS",
      brew_tea: "ΤΣΑΙ",
      brew_barista_tools: "ΕΡΓΑΛΕΙΑ BARISTA",
      brew_beverages: "BEVERAGES",
      brew_cold_brew: "COLD BREW",
      brew_grinders: "ΜΥΛΟΙ ΑΛΕΣΗΣ",
      brew_stock: "STOCK SPECIALS",
      brew_parts: "ΑΝΤΑΛΛΑΚΤΙΚΑ",
      lunora_coffees: "ΚΑΦΕΔΕΣ",
      lunora_joy: "ΡΟΦΗΜΑΤΑ JOY",
      lunora_beverages: "ΡΟΦΗΜΑΤΑ",
      lunora_syrups: "ΣΙΡΩΠΙΑ",
      lunora_consumables: "AΝΑΛΩΣΙΜΑ",
      company_about: "ΣΧΕΤΙΚΑ ΜΕ ΕΜΑΣ",
      company_payment: "ΤΡΟΠΟΙ ΠΛΗΡΩΜΗΣ",
      company_shipping: "ΤΡΟΠΟΙ ΑΠΟΣΤΟΛΗΣ",
      company_returns: "ΕΠΙΣΤΡΟΦΕΣ",
      terms: "Όροι Χρήσης",
      cookies: "Πολιτικη Cookies",
      gdpr: "GDPR",
      company_name: "ΣΑΠΛΑΙ ΓΙΟΥΝΙΚ Α.Ε.",
      company_address_1: "ΒΙ.ΠΕ. ΠΑΤΡΩΝ O.T. 37-38",
      company_address_2: "ΤΚ: 25200 ΠΑΤΡΑ, ΕΛΛΑΔΑ",
      company_phone: "+30 2144001600",
      company_email: "sales@brewspecialists.gr",
      newsletter: "NEWSLETTER",
      newsletter_title:
        "Εγγραφείτε στην ομάδα για να λαμβάνετε πρώτοι τα νέα μας",
      newsletter_email_label: "Email *",
      newsletter_button: "ΕΓΓΡΑΦΗ",
      newsletter_email_required: "Το email είναι υποχρεωτικό",
      newsletter_email_invalid: "Μη έγκυρη διεύθυνση email",
      newsletter_terms_text: "Διάβασα και αποδέχομαι τους",
      newsletter_terms_link: "όρους χρήσης",
      newsletter_terms_error: "Πρέπει να αποδεχθείτε τους Όρους χρήσης",
      newsletter_privacy_text: "και την",
      newsletter_privacy_link: "πολιτική απορρήτου",
      "We use cookies!": "Χρησιμοποιούμε cookies!",
      "We use cookies to improve your experience. You can accept all, reject non-essential, or customize preferences.":
          "Χρησιμοποιούμε cookies για να βελτιώσουμε την εμπειρία σας. Μπορείτε να αποδεχθείτε όλα τα cookies, να απορρίψετε τα μη απαραίτητα ή να προσαρμόσετε τις προτιμήσεις σας.",
      "Accept all": "Αποδοχή όλων",
      "Customize": "Ρυθμίσεις",
      "Reject": "Απόρριψη",
      "Cookie Settings": "Ρυθμίσεις cookies",
      "Customize consent preferences. Functional cookies are always active. You can enable performance and marketing cookies.":
          "Προσαρμόστε τις προτιμήσεις συγκατάθεσής σας. Τα απαραίτητα cookies είναι πάντα ενεργά. Μπορείτε να ενεργοποιήσετε cookies απόδοσης και μάρκετινγκ.",
      "Always active": "Πάντα ενεργό",
      "Required cookies to make the website work properly.":
          "Απαραίτητα cookies για τη σωστή λειτουργία της ιστοσελίδας.",
      "Analytics cookies that help us improve the website.":
          "Cookies ανάλυσης που μας βοηθούν να βελτιώνουμε την ιστοσελίδα.",
      "Marketing cookies for personalized advertising.":
          "Cookies μάρκετινγκ για εξατομικευμένη διαφήμιση.",
      "Reject non-essential": "Απόρριψη μη απαραίτητων",
      "Save preferences": "Αποθήκευση προτιμήσεων"

    },
    en: {
      brew: "BREW",
      lunora: "LUNORA",
      company: "COMPANY",
      contact: "CONTACT",
      brew_filters: "FILTERS",
      brew_pour_over: "POUR OVER",
      brew_scales: "SCALES",
      brew_pitchers: "PITCHERS",
      brew_kettles: "KETTLES",
      brew_thermos: "THERMOS - TUMBLERS",
      brew_cleaners: "CLEANERS",
      brew_espresso: "ESPRESSO MAKERS",
      brew_tea: "TEA",
      brew_barista_tools: "BARISTA TOOLS",
      brew_beverages: "BEVERAGES",
      brew_cold_brew: "COLD BREW",
      brew_grinders: "GRINDING MILLS",
      brew_stock: "STOCK SPECIALS",
      brew_parts: "PARTS",
      lunora_coffees: "COFFEES",
      lunora_joy: "JOY BEVERAGES",
      lunora_beverages: "BEVERAGES",
      lunora_syrups: "SYRUPS",
      lunora_consumables: "CONSUMABLES",
      company_about: "ABOUT US",
      company_payment: "PAYMENT METHODS",
      company_shipping: "SHIPPING METHODS",
      company_returns: "RETURNS",
      terms: "Terms of Use",
      cookies: "Cookie Policy",
      gdpr: "GDPR",
      company_name: "SUPPLY UNIQUE S.A.",
      company_address_1: "PATRAS INDUSTRIAL AREA BLOCK 37-38",
      company_address_2: "25200 PATRAS, GREECE",
      company_phone: "+30 2144001600",
      company_email: "sales@brewspecialists.gr",
      newsletter: "NEWSLETTER",
      newsletter_title: "Subscribe to our group to receive our news first",
      newsletter_email_label: "Email *",
      newsletter_button: "SUBSCRIBE",
      newsletter_email_required: "Email is required",
      newsletter_email_invalid: "Invalid email format",
      newsletter_terms_text: "I have read and accept the",
      newsletter_terms_link: "terms of use",
      newsletter_terms_error: "You must accept the terms and conditions",
      newsletter_privacy_text: "and the",
      newsletter_privacy_link: "privacy policy",
    },
  },
  [Namespaces.CART_NOTIFICATION]: {
    el: {
      product_added_success: "Το Προϊόν προστέθηκε στο καλάθι!",
      combine_with: "Μπορείς να το συνδυάσεις με:",
      view_cart: "ΠΡΟΒΟΛΗ ΚΑΛΑΘΙΟΥ",
      continue_shopping: "ΣΥΝΕΧΕΙΑ ΑΓΟΡΩΝ",
      code_label: "ΚΩΔΙΚΟΣ:",
      add_button: "ΠΡΟΣΘΗΚΗ",
      no_image: "No Image",
      "Additional information":"Πρόσθετες πληροφορίες",
      "Delivery information":"Στοιχεία παράδοσης",
      "Invoice Details":"Στοιχεία τιμολογίου",
      "Shipping Carrier":"Μεταφορική",
      "My order":"Η παραγγελία μου",
      "Order Confirmation":"Επιβεβαίωση παραγγελίας",
      "Your order has been successfully placed. You will soon receive emails with updates about its progress.":"Η παραγγελία σας έχει καταχωρηθεί με επιτυχία. Σύντομα θα λάβετε σχετικά email για την εξέλιξή της.",
      "Order Number":"Αρ.Παραγγελίας",
      "Date":"Ημερ/νια",
      "Total":"Σύνολο",
      "Payment Method":"Πληρωμή με"
    },
    en: {
      product_added_success: "Product added to cart!",
      combine_with: "You can combine it with:",
      view_cart: "VIEW CART",
      continue_shopping: "CONTINUE SHOPPING",
      code_label: "CODE:",
      add_button: "ADD",
      no_image: "No Image",
    },
  },
  [Namespaces.DASHBOARD]: {
    el: {
      title: "Ο ΛΟΓΑΡΙΑΣΜΟΣ ΜΟΥ",
      subtitle:
        "Εδώ μπορείτε να επεξεργαστείτε τις προσωπικές σας πληροφορίες και τις παραγγελίες σας.",
      logout: "ΑΠΟΣΥΝΔΕΣΗ",
      accountDetails: "ΣΤΟΙΧΕΙΑ ΛΟΓΑΡΙΑΣΜΟΥ",
      orderHistory: "ΙΣΤΟΡΙΚΟ ΠΑΡΑΓΓΕΛΙΩΝ",
      productReturns: "ΕΠΙΣΤΡΟΦΕΣ ΠΡΟΪΟΝΤΩΝ",
      receiptProof: "ΑΠΟΔΕΙΚΤΙΚΑ ΠΑΡΑΛΑΒΗΣ",
      addresses: "OI ΔΙΕΥΘΥΝΣΕΙΣ MOY",
      coupons: "TA ΚΟΥΠΟΝΙΑ MOY",
      Profile:"ΠΡΟΦΙΛ",
      "Be sure you have updated your personal information if something changed.":"Βεβαιωθείτε ότι έχετε ενημερώσει τα προσωπικά σας στοιχεία αν έχει αλλάξει κάτι.",
      "Name":"Όνομα",
      "AFM":"ΑΦΜ",
      "Company":"Εταιρεία",
      "Email":"Email",
      "Country":"Χώρα",
      "Phone":"Τηλέφωνο",
      "Change Password":"Αλλαγή Κωδικού",
      "Current Password":"Τρέχων Κωδικός",
      "New Password":"Νέος κωδικός",
      "Confirm Password":"Επιβεβαίωση κωδικού",
      "Register to our newsletter!":"Εγγραφή/ήδη στο newsletter μας!",
      "Receive special offers from our partners!":"Λάβετε ειδικές προσφορές από τους συνεργάτες μας!",
      "Save":"Αποθήκευση",
      "Returns":"Επιστροφές",
      "Order History":"Ιστορικό Παραγγελιών",
      "Order Number":"Αρ.Παραγγελίας",
      "Date":"Ημερομηνία",
      "Status":"Κατάσταση",
      "Total":"Σύνολο",
      "View":"Προβολή",
      "Invoice":"Τιμολόγιο",
      "My Coupons":"Τα κουπόνια μου",
      "Here you can find all your available coupons.":"Παρακάτω μπορείς να βρεις όλα τα διαθέσιμα κουπόνια σου.",
      "Coupon Code":"Κωδικός Κουπονιού",
      "Description":"Περιγραφή",
      "Valid until":"Ισχύει έως",
      "My addresses":"Οι διευθύνσεις μου",
      "There are no stored addresses.":"Δεν υπάρχουν αποθηκευμένες διευθύνσεις.",
      "New address":"Νέα διεύθυνση",
      "Delete address":"Διαγραφή διεύθυνσης",
      "Do you want to delete this address?":"Θέλεις να διαγράψεις αυτή τη διεύθυνση;",
      "Cancel":"Ακύρωση",
      "Delete...":"Διαγραφή...",
      "Yes,delete":"Ναι, διαγραφή",
      "Your address":"Η διευθυνσή σας",
      "Return":"Επιστροφή",
      addressFormInstruction: "Για να {{action}} μια διεύθυνση, παρακαλούμε συμπληρώστε τα παρακάτω πεδία.",
      editAddressAction: "επεξεργαστείτε",
      addAddressAction: "προσθέσετε",
      "Address":"Διεύθυνση",
      "Zip Code":"T.K",
      "Region":"Νομός / Περιοχή",
      "County":"Περιφέρεια",
      "Address Phone":"Τηλέφωνο",
      "City":"Πόλη",
      "Additional Information":"Πρόσθετες πληροφορίες",
      "Save changes":"Αποθήκευση αλλαγών",
      "Payment Method":"Πληρωμή με",
      "My order":"Η παραγγελία μου",
      "Value without tax":"Καθαρή αξία",
      "Vat":"ΦΠΑ",
      "Shipping":"Έξοδα αποστολής",
      "Final total":"Τελικό σύνολο",
    "In progress" : "Σε εξέλιξη",
    "Completed" : "Ολοκληρώθηκε",
      "Cancelled" : "Ακυρώθηκε",
      'Edit':'Επεξεργασία',
      'Delete':'Διαγραφή',
      "Invoice address":"Διεύθυνση τιμολόγησης"
    },
    en: {
      title: "MY ACCOUNT",
      subtitle: "Here you can edit your personal information and orders.",
      logout: "LOGOUT",
      accountDetails: "ACCOUNT DETAILS",
      orderHistory: "ORDER HISTORY",
      productReturns: "PRODUCT RETURNS",
      receiptProof: "RECEIPT PROOF",
      addresses: "MY ADDRESSES",
      coupons: "MY COUPONS",
      addressFormInstruction: "To {{action}} an address, please fill in the fields below.",
      editAddressAction: "edit",
      addAddressAction: "add",
    },
  },
   [Namespaces.PRODUCT_INFO]: {
    el: {
      subcategory_default: "ΥΠΟΚΑΤΗΓΟΡΙΑ",
      brand_default: "BRAND",
      sku_label: "ΚΩΔΙΚΟΣ:",
      availability_backorder_default: "ΚΑΤΟΠΙΝ ΠΑΡΑΓΓΕΛΙΑΣ",
      backorder_badge: "ΚΑΤΟΠΙΝ ΠΑΡΑΓΓΕΛΙΑΣ", 
      no_image: "ΧΩΡΙΣ ΕΙΚΟΝΑ",
      short_description_fallback: "", 
      choose_color: "ΕΠΙΛΕΞΕ ΧΡΩΜΑ",
      add: "ΠΡΟΣΘΗΚΗ",
      share: "Μοιράσου το",
      withoutVat: "χωρίς ΦΠΑ",
      description: "ΠΕΡΙΓΡΑΦΗ",
      Specifications: "ΧΑΡΑΚΤΗΡΙΣΤΙΚΑ",
      "Complete order":"Ολοκλήρωση παραγγελίας",
      "Delivery information":"Στοιχεία παράδοσης",
      "Delivery address":"Διεύθυνση Παράδοσης",
      "Name":"Ονοματεπώνυμο",
      "Street":"Οδός",
      "Address 2":"Διεύθυνση 2",
      "Zip Code":"T.K",
      "City":"Πόλη",
      "Add new address":"Προσθήκη νέας Διεύθυνσης",
      "Address type":"Είδος Διεύθυνσης",
      "Company name":"Όνομα Εταιρίας",
      "Phone":"Τηλέφωνο",
      "E-mail":"E-mail",
      "Country":"Χώρα",
      "Additional information":"Πρόσθετες Πληροφορίες",
      "Notes for the order,the address,etc":"Σημειώσεις για την παραγγελια,την διεύθυνση ,κ.λ.π",
      "Shipping way":"Τρόπος παράδοσης",
      "Cooperating transport companies":"Συνεργαζόμενες μεταφορικές",
      "Please select one of the following shipping carriers:":"Επιλέξτε μια απο τις παρακάτω μεταφορικές:",
      "Shipping carrier chosen by the recipient":"Μεταφορική της επιλογής του παραλήπτη",
      "Add new shipping carrier":"Προσθήκη νέας μεταφορικής",
      "Please enter the contact details of the shipping carrier you selected:":"Παρακαλώ εισάγετε τα στοιχεία επικοινωνίας για την μεταφορική της επιλογής σας:",
      "Carrier Name":"Όνομα μεταφορικής",
      "Contract":"Επικοινωνία",
      "Delivery Date":"Ημερ/νια Παράδοσης",
      "Save this carrier to my account":"Αποθήκευση της μεταφορικής στο λογαριασμό μου",
      "I agree to the terms of service. (Read the terms of service)":"Συμφωνώ με τους όρους χρήσης της υπηρεσίας.(Διαβάστε τους όρους χρήσης)",
      "Courier":"Courier",
      "Payment way":"Τρόπος πληρωμής",
      "I have read and accept the Terms of Service and the Privacy Policy.": "Διάβασα και αποδέχομαι τους όρους χρήσης και την Πολιτική απορρήτου.",
      "My order":"Η παραγγελία μου",
      "Value without tax":"Καθαρή Αξία",
      "Shipping":"Μεταφορικά",
      "Vat":"ΦΠΑ",
      "Total":"Τελικό Σύνολο",
      "Confirm order":"Επιβεβαίωση παραγγελίας",
      "My cart":"Το καλάθι μου",
      "Product":"Προϊον",
      "Products":"Προϊόντα",
      "Your cart is empty":"Το καλάθι σου είναι άδειο",
      "Add another!":"Πρόσθεσε ακόμα!",
      "Continue shopping":"Συνέχεια αγορών",
      "Do you have a discount coupon?":"Έχεις κουπόνι έκπτωσης;",
      "Enter the code":"Εισάγετε τον κωδικό",
      "Add":"Προσθήκη",
      "Remove coupon":"Αφαίρεση κουπονιού",
      "Value without vat":"Καθαρή αξία",
      "Discount":"Έκπτωση",
      "Complete Order":"Ολοκλήρωση παραγγελίας",
      "available": "Διαθέσιμο",
      "limited": "Περιορισμένη διαθεσιμότητα",
      "on_order": "Διαθέσιμο κατόπιν παραγγελίας",
      "unavailable": "Μη διαθέσιμο",
      'Code':'Κωδικός',

    },
    en: {
      subcategory_default: "SUBCATEGORY",
      brand_default: "BRAND",
      sku_label: "CODE:",
      availability_backorder_default: "ON BACKORDER",
      backorder_badge: "ON BACKORDER",
      no_image: "No Image",
      short_description_fallback: "",
      choose_color: "CHOOSE COLOR",
      add: "ADD",
      share: "Share it",
      withoutVat: "without VAT",
      description: "DESCRIPTION",
      Specifications: "SPECIFICATIONS",
      "available": "Available",
      "limited": "Limited availability",
      "on_order": "Available on order",
      "unavailable": "Unavailable"
    },
  },
};

export default locales;
